import { useSearchParams } from "react-router-dom"

// The search-param key a Tabs instance persists its active tab under.
function getTabParamKey(id: string) {
  return id ? `${id}-tab` : "tab"
}

export function useTabParam(id: string, defaultTab: string) {
  const [searchParams, setSearchParams] = useSearchParams()
  const paramKey = getTabParamKey(id)
  const tab = searchParams.get(paramKey) ?? defaultTab

  function setTab(value: string) {
    setSearchParams(
      (prev) => {
        if (value === defaultTab) {
          prev.delete(paramKey)
        } else {
          prev.set(paramKey, value)
        }
        return prev
      },
      { replace: true },
    )
  }

  return [tab, setTab] as const
}
